<div class="toggle">
  <span class="rv-flex flex-fs" (click)="open = !open">
    <riv-icon *ngIf="open" [name]="'ChevronUp'"></riv-icon>
    <riv-icon *ngIf="!open" [name]="'ChevronDown'"></riv-icon>
    <ng-content select="[heading]"></ng-content>
  </span>
  <div *ngIf="open"><ng-content></ng-content></div>
</div>
